import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
  Badge,
  Breadcrumb,
  Button,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Table,
  Tooltip,
  message,
} from "antd";
import {
  CloseCircleFilled,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  SearchOutlined,
  PrinterOutlined,
  PrinterFilled
} from "@ant-design/icons";
import DatePicker from "react-modern-calendar-datepicker";
import moment from "moment-jalaali";
import { SetRoute } from "../scripts/action";
import { CheckPermission, PriceFormat } from "../scripts/helpers";
import { Constants, Permissions } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import PaginationInfo from "../components/PaginationInfo";
import OrderForm from "../forms/Order";
import OrderView from "../views/Order";
import PrintView from "../views/Print";
import AdvanceSearchDetailForm from "../forms/AdvanceSearchDetail";

class advanceSearchReport extends Component {
  constructor() {
    super();

    this.state = {
      countries: [],
      data: [],
      filter: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      selected: {},
      visible: false
    };

 

    this.formRef = React.createRef();
  }

  fetch = (params = {}) => {
    const {
      filterEndDate,
      filterSearch,
      filterStartDate,
      filterByTime
    } = this.state;

    params.q = filterSearch;
    params.endDate = filterEndDate
      ? moment(
          `${filterEndDate.year}-${filterEndDate.month}-${filterEndDate.day}`,
          Constants.jDateFormat
        ).format(Constants.dateFormat)
      : null;
    params.startDate = filterStartDate
      ? moment(
          `${filterStartDate.year}-${filterStartDate.month}-${filterStartDate.day}`,
          Constants.jDateFormat
        ).format(Constants.dateFormat)
      : null;
  
    params.time = filterByTime
    this.setState({ loading: true });

    API.advanceSearchReport
      .list(params)
      .then((result) => {
        if (result.data) {
          this.setState({
            loading: false,
            data: result.data.data,
            pagination: {
              ...this.state.pagination,
              ...{
                current: result.data.current_page,
                pageSize: result.data.per_page,
                total: result.data.total,
              },
            },
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };



  showModal = (order = {}) => {
    this.setState({ visible: true, selected: order });

    setTimeout(() => {
      this.formRef.current.handleDidMount(this.state.filterByTime, order.text);
    }, 0);
  };

  hideModal = () => {
    this.setState({ visible: false });

    setTimeout(() => {
      this.formRef.current.handleWillUnmount();
    }, 0);
  };




  handleFilter = (value, obj) => {
    const state = {};
    state[obj] = value;

    this.setState(state);

    setTimeout(() => {
      this.fetch({ page: 1 });
    }, 0);
  };

  handleDelete = (id) => {
    Modal.confirm({
      title: Resources.confirmDeleteOffer,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.order
          .delete(id)
          .then((result) => {
            message.success(result.message);

            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  

  handleTableChange = (pagination) => {
    this.fetch({ page: pagination.current });
  };

  async componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;

    onSetRoute({ openKey: parentName, selectedKey: routeName });

    if (this.props.match.params.phone) {
      this.props.history.replace(`/orders`);
      this.handleFilter(this.props.match.params.phone, "filterSearch");
    } else {
      this.fetch({ page: 1 });
    }
    
  }
 
  render() {
    const {
      data,

      loading,

      pagination,

      visible, submitting
    } = this.state;
    const { permissions } = this.props;

    const columns = [
     
    
      {
        title: `${Resources.search} `,
        dataIndex: "text",
        className: "col-center",
      },
   
  
      {
        title: `${Resources.count} `,
        dataIndex: "total",
        className: "col-center",
      },
      {
        title: Resources.action,
        dataIndex: 'id',
        className: 'col-center',
        width: '120px',
        render: (val, record) => (
            <Fragment>
                <Tooltip title={Resources.show}>
                    <Button type="link" icon={<EyeOutlined />} onClick={() => this.showModal(record)} />
                </Tooltip>
               
            </Fragment>
        )
    }
    ];    
  
 

    return (
      <Fragment>
      
        {console.log(data)}
        <Breadcrumb>
          <Breadcrumb.Item> {Resources.advanceSearchReport} </Breadcrumb.Item>
        </Breadcrumb>
        <div className="ant-content">
          <Row gutter={24} style={{ marginBottom: 16 }}>
            
           <Col xs={24} md={6}>
                         <Select
                           onChange={(value) => this.handleFilter(value, "filterByTime")}
                           placeholder={Resources.filterByTime}
                           optionFilterProp="name"
                           style={{ display: "block" }}
                           showSearch
                           allowClear
                         >
                             <Select.Option value="daily" name="daily">
                               {Resources.daily}
                             </Select.Option>
                             <Select.Option value="weekly" name="weekly">
                               {Resources.weekly}
                             </Select.Option>
                             <Select.Option value="monthly" name="monthly">
                               {Resources.monthly}
                             </Select.Option>
                             <Select.Option value="yearly" name="yearly">
                               {Resources.yearly}
                             </Select.Option>
                         </Select>
                       </Col>
            <Col xs={24} md={{ span: 6, offset: 6 }}>
              <Tooltip >
                <Input
                  type="text"
                  prefix={<SearchOutlined />}
                  placeholder={Resources.search}
                  defaultValue={this.props.match.params.phone}
                  onChange={({ target: { value } }) =>
                    this.handleFilter(value, "filterSearch")
                  }
                  allowClear
                />
              </Tooltip>
            </Col>
          </Row>

          
        </div>
        <div className="ant-content">
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            onChange={this.handleTableChange}
            pagination={pagination}
            size="small"
            rowKey="id"
            scroll={{ x: 1000 }}
          />
          {!!pagination.total && (
            <PaginationInfo
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
            />
          )}
        </div>

        <AdvanceSearchDetailForm ref={this.formRef}  onCancel={this.hideModal} onSubmit={this.hideModal} submitting={submitting} visible={visible} />
        
      </Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      permissions: {
        action: CheckPermission(state.app.user, Permissions.cart_option),
        view: CheckPermission(state.app.user, Permissions.cart_view),
      },
    };
  },
  (dispatch) => {
    return {
      onSetRoute: (data) => dispatch(SetRoute(data)),
    };
  }
)(advanceSearchReport);
